import { render, staticRenderFns } from "./ListaPedidoExames.vue?vue&type=template&id=67d4ddcc"
import script from "./ListaPedidoExames.vue?vue&type=script&lang=js"
export * from "./ListaPedidoExames.vue?vue&type=script&lang=js"
import style0 from "./ListaPedidoExames.vue?vue&type=style&index=0&id=67d4ddcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports